import { useState, useEffect } from "react";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { getAcademicSessions } from "../../../ApiService/ApiService";
import SessionTable from "./SessionTable";
import AddSession from "./AddSession";
import { Add } from "@mui/icons-material";

function SessionSection() {
  const [sessions, setSessions] = useState({});
  const [showAddSession, setShowAddSession] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchSessions();
  }, []);

  const fetchSessions = async () => {
    try {
      setLoading(true);
      const response = await getAcademicSessions();
      setSessions(response?.data);
    } catch (err) {
      console.error("Error fetching sessions:", err);
    } finally {
      setLoading(false);
    }
  };

  const renderMainContent = () => {
    if (showAddSession) {
      return (
        <AddSession
          fetchSessions={fetchSessions}
          setShowAddSession={setShowAddSession}
        />
      );
    } else {
      return <SessionTable sessions={sessions} fetchSessions={fetchSessions} />;
    }
  };

  return (
    <>
      <Box
        sx={{
          display: showAddSession ? "none" : "flex",
          justifyContent: "space-between",
        }}
      >
        <Typography
          paragraph
          sx={{
            fontWeight: 600,
            fontSize: 22,
            fontFamily: "Barlow, sans-serif",
          }}
          xs={4}
          sm={4}
          md={6}
          lg={8}
          xl={8}
        >
          Academic Sessions
        </Typography>
        <Button
          xs={8}
          sm={8}
          md={6}
          lg={4}
          xl={4}
          onClick={() => setShowAddSession(true)}
          variant="contained"
          color="primary"
          size="small"
          sx={{
            mb: 2,
            textTransform: "unset",
            borderRadius: 2,
          }}
        >
          <Add fontSize="small" /> Add Session
        </Button>
      </Box>
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", marginTop: 2 }}>
          <CircularProgress />
        </Box>
      ) : (
        <>{renderMainContent()}</>
      )}
    </>
  );
}

export default SessionSection;
